import { motion, useReducedMotion } from 'framer-motion'

// Step 2 — the primary BET action + Auto Bet toggle. Shared across games.
const BetVisual = () => {
  const reduce = useReducedMotion()

  return (
    <div className="htp-actions">
      <motion.div
        className="htp-cta is-bet"
        animate={reduce ? undefined : { scale: [1, 0.97, 1] }}
        transition={reduce ? undefined : { repeat: Infinity, duration: 2.2, ease: 'easeInOut' }}
      >
        PLACE BET
      </motion.div>
      <div className="htp-pill">
        <span>Auto Bet</span>
        <span className="htp-mini-toggle" aria-hidden="true" />
      </div>
    </div>
  )
}

export default BetVisual
